import { AUTH_TOKEN } from "../constants/common";
import { getLocalStorageData } from "./LocalStorageAccess";

// A function, not a constant. This used to be evaluated once at module load, so
// it kept answering "signed in" for the rest of the document's life even after
// the token had been removed - and Layout's `authenticated` state, which does
// change, could then disagree with the route guard that reads this. That
// disagreement is what produced an endless /generate_auth_redirect_url ->
// /users/sign_in -> /vehicles bounce.
//
// `toJson` hands back the raw string when the stored value is not JSON, so a
// literal "undefined" written by setLocalStorageData(AUTH_TOKEN, undefined) has
// to be rejected explicitly - it is a truthy string.
export const isAuth = () => {
  const token = getLocalStorageData(AUTH_TOKEN);
  return !(token == null || token === "undefined");
};
